import Select from "react-select";
import { useState } from "react";

const CustomSelect = (props) => {
  const data = props.data;
  const error = props.error;
  const state = props.state;
  const locationDate = props?.locationDate;
  const [selected, setSelected] = useState(locationDate?.TransType || "");

  let options = data?.values?.filter((option) => {
    if (state?.[data?.extra?.depends] !== undefined) {
      return option?.[data?.extra?.depends] == state?.[data?.extra?.depends];
    }
    return true;
  });

  const handleSelectChange = (e) => {
    setSelected(e);
    props?.handleInput({
      target: {
        name: data?.name,
        value: e?.value,
      },
    });
  };

  return (
    <>
      <div className="col-md-3">
        <label htmlFor={data.name}>
          {data.label}{" "}
          {data?.required && <span className="text-danger">*</span>}
        </label>

        <Select
          cacheOptions
          defaultOptions
          tabSelectsValue
          placeholder={`Select...`}
          isClearable={true}
          classNamePrefix="react-select"
          options={options}
          value={
            state?.[data?.name]
              ? selected
              : options?.find((p) => p.value == "") || ""
          }
          onChange={(e) => handleSelectChange(e)}
          components={{
            IndicatorsContainer: () => null,
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              minHeight: "0px",
            }),
            valueContainer: (baseStyles, state) => ({
              ...baseStyles,
              paddingTop: "0px",
              paddingBottom: "0px",
            }),
            input: (baseStyles, state) => ({
              ...baseStyles,
              paddingTop: "0px",
              paddingBottom: "0px",
              marginTop: "0px",
              marginBottom: "0px",
            }),
            dropdownIndicator: (baseStyles, state) => ({
              ...baseStyles,
              paddingTop: "0px",
              paddingBottom: "0px",
            }),
            option: (baseStyles, state) => ({
              ...baseStyles,
              paddingTop: "0px",
              paddingBottom: "0px",
            }),
          }}
        />
        <span className="text-danger">{error}</span>
      </div>
    </>
  );
};

export default CustomSelect;
